import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 22,
	viewBox: "0 0 18 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Flag" }), /* @__PURE__ */ _jsx("path", {
		d: "M1 14C1 14 2 13 5 13C8 13 10 15 13 15C16 15 17 14 17 14V2C17 2 16 3 13 3C10 3 8 1 5 1C2 1 1 2 1 2L1 21",
		stroke: "#F38744",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgFlag;
